import { Location } from 'history'
import React, { useEffect, useRef } from 'react'
import { match as Match, Route } from 'react-router-dom'
import { getAnalyticsObject, getAnalyticsContext } from '../hooks/useAnalytics'

function PageAnalyticsComponent({
  location,
  match,
}: {
  location: Location
  match: Match<{}>
}) {
  const startRef = useRef(true)
  useEffect(
    () => {
      const properties = {
        title: 'Boarding',
        referrer: null,
        search: null,
        url: match.path,
        path: match.path,
        start: startRef.current,
      }

      const context = getAnalyticsContext()
      const analytics = getAnalyticsObject()

      if (!analytics) {
        // eslint-disable-next-line no-console
        console.info(
          '[Analytics] Not loaded - Printing page tracking',
          properties
        )
      } else {
        analytics.page('Boarding', properties, { context })
      }

      startRef.current = false
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location.pathname]
  )
  return null
}

export function PageAnalytics() {
  return (
    <Route
      path={[
        '/organization/create',
        '/organization/join/:inviteToken',
        '/organization/join-link/:domain/:organizationInviteToken/:joinOrigin?',
        '/organization/select/direct',
        '/organization/select',
        '/organization/create-from-oauth',
        '/organization/autojoin/:domain/:membershipStatus?',
        '*',
      ]}
      render={({ match, location }) => {
        return <PageAnalyticsComponent match={match} location={location} />
      }}
    />
  )
}
